import { useQuery } from '@tanstack/react-query';
import { DATASET_CHILD_DATASETS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_child_datasets_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';

import { Datasets } from '@/types/datasets.ts';

const useRetrieveChildDatasets = (datasetId?: string) => {
  const apiClient = useApiClient();

  return useQuery<Datasets, AxiosError>({
    queryKey: DATASET_CHILD_DATASETS_KEY(datasetId),
    enabled: !!datasetId,
    queryFn: async () => {
      const response = await apiClient.get<Datasets>(get_child_datasets_url(datasetId));
      return response.data;
    },
  });
};

export default useRetrieveChildDatasets;
